export const BUYER = 1;
export const SELLER = 0;

const ROLES = { BUYER, SELLER };

export default ROLES;
